var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChSwap = function SvgChSwap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.366 16.287a.725.725 0 0 0 1.025-1.025l-1.663-1.663 10.343-.003a.724.724 0 0 0 .726-.726.724.724 0 0 0-.726-.725H4.729l1.663-1.663a.725.725 0 0 0-1.025-1.025l-2.903 2.9a.723.723 0 0 0 0 1.024l2.903 2.903v.003Zm10.22-10.643a.723.723 0 0 0 0-1.025l-2.903-2.906a.725.725 0 0 0-1.025 1.025l1.663 1.663-10.344.003a.724.724 0 0 0-.725.726c0 .402.323.725.725.725h10.344l-1.663 1.663a.725.725 0 0 0 1.025 1.025l2.902-2.902v.003Z",
    fill: "currentColor"
  })));
};
export default SvgChSwap;